import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Rynco Li
 * id EB9242D1-9D25-4141-A1A0-06636EC84541
 * name card-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card-outline.svg
 * tags
 * - Form 
 */
export const CardOutlineIcon = createSvgIcon(<><path d="M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M4,6V18H20V6H4Z" /></>, 'CardOutlineIcon');
export default CardOutlineIcon